import { Text } from '@/_components';
import { isTicketOpen } from '@/_containers/support/shared/helper';
import type { SupportStatus } from '@/_containers/support/shared/schemas/support-query-schema';
import { dateTime } from '@/_shared';

type TicketMetadataProps = {
  ticketStatus: SupportStatus;
  requesterName: string;
  companyName?: string;
  dueBy: string | null;
};

export function TicketMetadata({ ticketStatus, requesterName, companyName, dueBy }: TicketMetadataProps) {
  const formatDueDate = (dateStr: string) => {
    const now = dateTime.now();
    const diffInDays = Math.ceil(dateTime.getDurationDifference(dateStr, now, 'day', false));

    if (diffInDays < 0) {
      return { text: `Overdue by ${Math.abs(diffInDays)} days`, isOverdue: true };
    } else if (diffInDays === 0) {
      return { text: 'Due today', isOverdue: false };
    } else {
      return { text: `Due in ${diffInDays} days`, isOverdue: false };
    }
  };

  const dueInfo = dueBy ? formatDueDate(dueBy) : null;

  return (
    <div className="space-y-0.5">
      <div className="flex items-center gap-1">
        <Text as="span" className="text-xs font-medium text-gray-600 dark:text-gray-400">
          {requesterName}
        </Text>
        {companyName && (
          <Text as="span" className="text-c-card-muted text-xs font-normal">
            ({companyName})
          </Text>
        )}
        {dueInfo && isTicketOpen(ticketStatus) && (
          <>
            <Text as="span" className="text-xs text-gray-600 dark:text-gray-400">
              •
            </Text>
            <Text
              as="span"
              className={`text-xs ${dueInfo.isOverdue ? 'text-error' : 'text-gray-600 dark:text-gray-400'}`}
            >
              {dueInfo.text}
            </Text>
          </>
        )}
      </div>
    </div>
  );
}
